import { HydratedData } from "./hooks/useHydratedData";

function getReportItemsHandler(isIndividual: boolean) {
  return isIndividual
    ? // @ts-expect-error - expecting error
      window.biweGenerateTextsIndividual
    : // @ts-expect-error - expecting error
      window.biweGenerateTextsGroup;
}

export function getReportItems(data: HydratedData, isIndividual: boolean) {
  try {
    return (
      getReportItemsHandler(isIndividual)?.(data.testSetsData.testSets, {
        minForming: data.testSetsData.minForming,
        maxForming: data.testSetsData.maxForming,
        minAvgForming: data.testSetsData.minAvgForming,
        maxAvgForming: data.testSetsData.maxAvgForming,
        minAvg: data.testSetsData.minAvg,
        maxAvg: data.testSetsData.maxAvg,
      }) || null
    );
  } catch (e: any) {
    console.error(e);
    return null;
  }
}
